import { Campo } from '@/components/Campo';

import type { CamposComunes, Comunes } from './comunes';
import { SelectorEspecialidad } from './SelectorEspecialidad';

/** Nombre, especialidad, idioma, etiquetas y descripción (se reusa en modales y pantallas). */
export function DatosComunes({
  valor,
  onCambio,
  nombreMax,
  campos = {},
  especialidadRequerida = false,
  deshabilitado = false,
}: {
  valor: Comunes;
  onCambio: (c: Partial<Comunes>) => void;
  nombreMax: number;
  campos?: CamposComunes;
  especialidadRequerida?: boolean;
  deshabilitado?: boolean;
}) {
  return (
    <fieldset disabled={deshabilitado} className="space-y-4">
      <Campo etiqueta="Nombre" ayuda={`Hasta ${nombreMax} caracteres.`}>
        <input
          className="input-vidrio"
          value={valor.name}
          required
          minLength={2}
          maxLength={nombreMax}
          onChange={(e) => onCambio({ name: e.target.value })}
        />
      </Campo>
      {(campos.especialidad !== false || campos.idioma !== false) && (
        <div className="grid gap-3 sm:grid-cols-2">
          {campos.especialidad !== false && (
            <Campo etiqueta={especialidadRequerida ? 'Especialidad *' : 'Especialidad'}>
              <SelectorEspecialidad
                valor={valor.specialtyId}
                requerido={especialidadRequerida}
                deshabilitado={deshabilitado}
                vacio={especialidadRequerida ? 'Elige una especialidad' : 'Sin especialidad'}
                onCambio={(specialtyId) => onCambio({ specialtyId })}
              />
            </Campo>
          )}
          {campos.idioma !== false && (
            <Campo etiqueta="Idioma">
              <select
                className="input-vidrio"
                value={valor.isEnglish ? 'en' : 'es'}
                onChange={(e) => onCambio({ isEnglish: e.target.value === 'en' })}
              >
                <option value="es">Español</option>
                <option value="en">Inglés</option>
              </select>
            </Campo>
          )}
        </div>
      )}
      {campos.etiquetas !== false && (
        <Campo etiqueta="Etiquetas" ayuda="Separadas por coma. Sirven para buscar.">
          <input
            className="input-vidrio"
            value={valor.tags}
            onChange={(e) => onCambio({ tags: e.target.value })}
          />
        </Campo>
      )}
      {campos.descripcion !== false && (
        <Campo etiqueta="Descripción">
          <textarea
            className="input-vidrio min-h-20"
            value={valor.description}
            maxLength={250}
            onChange={(e) => onCambio({ description: e.target.value })}
          />
        </Campo>
      )}
    </fieldset>
  );
}
